import { StyleSheet } from 'react-native';

import { LAYOUT, THEME } from '../../../../reactor/common';

const { UNIT, OFFSET } = THEME;

export default StyleSheet.create({
  container: {
    width: '100%',
    height: '100%',
  },

  navigation: {
    ...LAYOUT.STYLE.ROW,
    justifyContent: 'center',
    left: 0,
    right: 0,
    bottom: 0,
    padding: OFFSET,
    position: 'absolute',
    zIndex: 1,
  },

  arrow: {
    height: UNIT * 4.8,
    width: UNIT * 4.8,
  },

  arrowDisabled: {
    opacity: 0,
  },
});
